import CxpWidget from '../cxp-config';
class AbstractWidgetBaseController {
    constructor(widget) {
        this.widget = widget;
        this.widgetPath = window.App.Portal.getWidgetPath(this.widget);
        this.cxpWidget = new CxpWidget(widget);
    }

    getSelector(query) {
        return this.widget.body.querySelector(query);
    }

    getSelectors(query) {
        return this.widget.body.querySelectorAll(query);
    }
}

export default AbstractWidgetBaseController;



// WEBPACK FOOTER //
// ./collection-institutional-portal/src/widgets/abstract/base/controller.js